export default "__VITE_ASSET__2d699065__"